

$('.js-title-popup').each(function(){

  let arrow = $(this).find('.arrow')
  let width = $(this).outerWidth()
  let left = $(this).offset().left
  let wWidth = $(window).innerWidth()
  let right = left + width

  if (right > wWidth){
    let newLeft = -(right - wWidth + 16)
    $(this).css('left', newLeft)

    arrow.css('left', (-newLeft + 8) )

  }

})
